import { render, staticRenderFns } from "./AccountConfig.vue?vue&type=template&id=1475cf29"
import script from "./AccountConfig.vue?vue&type=script&lang=js"
export * from "./AccountConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports